document.addEventListener("DOMContentLoaded", function () {
  // Quiz Start
  var mainContent = document.getElementById("MainContent");
  var sections = "";
  var startButton = "";

  if (mainContent) {
    sections = mainContent.querySelectorAll(".shopify-section");

    if (sections) {
      startButton = sections.item(0).querySelector(".button--primary");
    }
  }

  Clinicians.QuizModal = Vue.component("Modal", {
    template: "#template-quiz-modal",
    props: ["data", "name"],
    data: function () {
      return {
        open: false,
      };
    },
    methods: {
      toggleModal: function () {
        this.open = !this.open;
      },
    },
  });

  const PERSIST_FIELDS = [
    "currentStepIndex",
    "tags",
    "goals",
    "error",
    "totalSteps",
    "day",
    "month",
    "year",
    "variables",
    "steps",
  ];

  // Quiz App
  Clinicians.QuizApp = new Vue({
    el: "#quiz",
    components: {
      "quiz-modal": Clinicians.QuizModal,
    },
    methods: {
      persist: function () {
        PERSIST_FIELDS.forEach((field) => {
          if (this[field]) {
            try {
              localStorage.setItem(field, JSON.stringify(this[field]));
            } catch (e) {
              //
            }
          }
        });
      },
      progress: function () {
        var percentage =
          ((this.currentStepIndex + 1) / this.steps.length) * 100;
        var css = "width:" + percentage + "%";
        return css;
      },
      handleize: function (input) {
        if (Array.isArray(input)) {
          input = input.join("-");
        }
        return input
          .toString()
          .toLowerCase()
          .replace(/[^\w\u00C0-\u024f]+/g, "-")
          .replace(/^-+|-+$/g, "");
      },
      animateNextStep: function (event) {
        if (event && event.target && event.target.type !== "radio") {
          // only applies for radio
          return;
        }

        const quizBox =
          event && event.target
            ? event.target.parentNode.querySelector(".quiz-box")
            : null;

        this.moving = true;

        if (quizBox) {
          quizBox.classList.add("flash");

          setTimeout(() => {
            quizBox.classList.remove("flash");
            this.moving = false;

            this.nextStep();
          }, 200);
        } else {
          this.moving = false;

          this.nextStep();
        }
      },
      injectVariables(input) {
        var output = input.slice();
        for (const [key, value] of Object.entries(this.variables)) {
          output = output.replace("[" + key + "]", value);
        }
        return output;
      },
      prevStep: function () {
        if (this.moving) {
          return false;
        }

        this.error = null;

        if (this.currentStepIndex > 0) {
          this.currentStepIndex--;
        }

        // update the url
        if ("URLSearchParams" in window) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.delete("quizStep");

          var newRelativePathQuery =
            window.location.pathname + "?" + searchParams.toString();
          history.pushState(null, "", newRelativePathQuery);
        }
      },
      nextStep: function () {
        if (this.moving) {
          return false;
        }

        var vthis = this,
          step = this.steps[this.currentStepIndex];

        this.error = null;

        if (
          step.variable !== undefined &&
          (this.variables[step.variable] === undefined ||
            this.variables[step.variable] == "")
        ) {
          if (step.answers !== undefined) {
            this.error = "Select an answer to continue.";
          } else {
            this.error = "Complete this field to continue.";
          }
        }

        if (
          step.answer == "date" &&
          (this.day == "" || this.month == "" || this.year == "")
        ) {
          this.error = "Complete this field to continue.";
        }

        if (step.selected !== undefined) {
          if (step.goals !== undefined && step.selected.length === 0) {
            this.error = "Select an answer to continue";
          } else if (
            step.tags !== undefined &&
            step.type !== "radio" &&
            step.selected.length === 0
          ) {
            this.error = "Select at least one answer to continue";
          }
        }

        if (this.error !== null) {
          return;
        }

        // Add goal steps to the steps array
        let advanceStep = true;

        if (step.goals !== undefined) {
          // Clear existing steps
          const update = this.steps.slice(0, this.currentStepIndex + 1);

          this.goals = {};

          // Add new ones
          step.selected.forEach(function (goal, index) {
            vthis.goals[goal] = [];
            Clinicians.QuizData.goalSteps[goal].forEach(function (goalStep) {
              goalStep.heading = goal;
              goalStep.goal = goal;
              goalStep.title = goalStep["when"]["title"][vthis.variables.who];

              update.push(goalStep);
            });
          });

          this.steps = update;
        }

        // Merge selected tags with session tag list
        if (step.tags !== undefined) {
          if (step.goal !== undefined) {
            this.mergeGoalTags(step.goal, step.selected, step.tags);
          } else {
            this.mergeTags(step.selected, step.tags);
          }
        } else if (step.goal) {
          // if it has a goal without tags (then it's a radio option like Yes / No)
          if (this.variables[step.variable]) {
            this.mergeGoalTags(
              step.goal,
              this.variables[step.variable],
              step.tags
            );
          }
        }

        // Advance current step index
        if (advanceStep) {
          this.currentStepIndex++;
        }

        // update the url
        if ("URLSearchParams" in window) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.set("quizStep", this.currentStepIndex + 1);
          searchParams.delete("start");

          var newRelativePathQuery =
            window.location.pathname + "?" + searchParams.toString();
          history.pushState(null, "", newRelativePathQuery);
        }

        if (window.dataLayer !== undefined) {
          window.dataLayer.push({
            event: "quizNextStep",
            step: this.steps[this.currentStepIndex],
          });
        }

        this.persist();
      },
      // Goals
      addGoalTag(goal, tag) {
        this.goals[goal].push(tag);

        if (window.dataLayer !== undefined) {
          window.dataLayer.push({
            event: "quizAddGoalTag",
            goal: goal,
            tag: tag,
          });
        }
      },
      removeGoalTag(goal, tag) {
        this.goals[goal] = this.goals[goal].filter(function (ele) {
          return ele != tag;
        });
      },
      mergeGoalTags(goal, selectedTags, stepTags) {
        var vthis = this;
        // First remove any existing tags added from this step
        if (stepTags) {
          stepTags.forEach(function (tag) {
            vthis.removeGoalTag(goal, tag.value);
          });
        }

        if (typeof selectedTags == "string") {
          selectedTags = [selectedTags];
        }

        if (selectedTags) {
          // Add selected tag(s)
          selectedTags.flat().forEach(function (tag) {
            //if ( tag === null ) return;
            vthis.addGoalTag(goal, tag);
          });
        }

        console.log("merging tags", goal, selectedTags, stepTags);
      },
      // Tags
      addTag(tag) {
        this.tags.push(tag);

        if (window.dataLayer !== undefined) {
          window.dataLayer.push({
            event: "quizAddTag",
            tag: tag,
          });
        }
      },
      removeTag(tag) {
        this.tags = this.tags.filter(function (ele) {
          return ele != tag;
        });
      },
      mergeTags(selectedTags, stepTags) {
        var vthis = this;
        // First remove any existing tags added from this step
        stepTags.forEach(function (tag) {
          vthis.removeTag(tag.value);
        });
        // Add selected tag(s)
        selectedTags.flat().forEach(function (tag) {
          if (tag === null) return;
          vthis.addTag(tag);
        });
      },
      disableOptions: function (option) {
        if (this.steps[this.currentStepIndex] === undefined) {
          return "";
        }

        var step = this.steps[this.currentStepIndex];
        if (step.max === undefined) {
          return false;
        }
        if (step.selected.indexOf(option) !== -1) {
          return false;
        }
        if (step.selected.length == step.max) {
          return true;
        }
        return false;
      },
      setVariableFromDate() {
        var step = this.steps[this.currentStepIndex];

        if (step) {
          this.variables[step.variable] =
            this.day + " " + this.month + " " + this.year;
        }
      },
      isSelectedClass(value) {
        var step = this.steps[this.currentStepIndex];
        if (
          this.steps[this.currentStepIndex] === undefined ||
          step.selected === undefined
        ) {
          return "";
        }
        var selectedJson = JSON.stringify(step.selected);
        var valueJson = JSON.stringify(value);

        return selectedJson.indexOf(valueJson) !== -1 ? "selected" : "";
      },
      isVariableClass(variable, value) {
        return this.variables[variable] == value ? "selected" : "";
      },
      sendEmail: function () {
        this.sendingEmail = true;

        if (window.dataLayer !== undefined) {
          window.dataLayer.push({
            event: "quizSendEmail",
          });
        }

        const data = [];

        document.querySelectorAll(".collection").forEach((collection) => {
          let viewAllButton = collection.querySelector(".quiz-view-all");
          let collectionLink = "";

          if (viewAllButton) {
            collectionLink = viewAllButton.getAttribute("href") ?? "";
          }

          if (collectionLink.substring(0, 1) == "/") {
            collectionLink = "https://www.clinicians.co.nz" + collectionLink;
          }

          let collectionTitle = collection.querySelector("h4");

          const collectionData = {
            title: collectionTitle?.innerText ?? "",
            link: collectionLink,
            products: [],
          };

          collection.querySelectorAll(".grid__item").forEach((item) => {
            const aTag = item.querySelector("a");
            let href = aTag?.getAttribute("href") ?? "";

            if (href.substring(0, 1) == "/") {
              href = "https://www.clinicians.co.nz" + href;
            }

            let priceNode = item.querySelector(".price-item--regular");
            let price = "";
            let title = "";
            let content = "";
            let type = "";

            let titleNode = item.querySelector(".card__heading");
            if (titleNode) {
              title = titleNode.textContent?.trim() ?? "";
            }

            if (priceNode) {
              price = priceNode.textContent?.trim() ?? "";
            }

            let contentNode = item.querySelector(".card__content");
            if (contentNode) {
              content = contentNode.textContent?.trim() ?? "";
            }

            let typeNode = item.querySelector(".product__type");
            if (typeNode) {
              type = typeNode.textContent?.trim() ?? "";
            }

            const record = {
              link: href,
              img: item.querySelector("img")?.getAttribute("src"),
              title: title,
              content: content,
              price: price,
              category: type,
            };

            // @ts-ignore
            collectionData.products.push(record);
          });

          data.push(collectionData);
        });

        fetch("https://clinicians-quiz.herokuapp.com/api/send", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: this.emailAddress,
            brand: "clinicians",
            firstName: this.firstName,
            lastName: this.lastName,
            emailOptIn:
              document.querySelector("#c-modal--email_checkbox")?.checked ??
              false,
            title:
              document.querySelector(".banner__heading").textContent?.trim() ??
              "",
            intro:
              document
                .querySelector(".banner__heading + .banner__text")
                .textContent?.trim() ?? "",
            collections: data,
          }),
        }).then((response) => {
          this.sendingEmail = false;
          this.sentEmail = true;
        });
      },
      hideEmailModal: function () {
        this.sendingEmail = false;
        this.sentEmail = false;
        this.showingEmailModal = false;
      },
      showEmailModal: function () {
        this.sendingEmail = false;
        this.sentEmail = false;
        this.showingEmailModal = true;
      },
    },
    watch: {
      currentStepIndex: function () {
        window.scrollTo(0, 0);

        // Show results
        if (this.steps[this.currentStepIndex] === undefined) {
          const title =
            Clinicians.QuizData.summary["when"]["title"][this.variables.who];
          const heading = this.injectVariables(title);

          Clinicians.showQuizResults({
            heading: heading,
            tags: this.tags,
            goals: this.goals,
          });

          if (window.dataLayer !== undefined) {
            window.dataLayer.push({
              event: "quizFinished",
              goals: this.goals,
              tags: this.tags,
            });
          }

          return;
        }

        var step = this.steps[this.currentStepIndex];

        // If this is an "if" card, check the condition
        if (
          step.if !== undefined &&
          this.variables[step.if.variable] != step.if.value
        ) {
          this.currentStepIndex++;
          return;
        }

        // Inject variables into titles & captions
        if (step.when !== undefined) {
          // Title
          if (step.when.title !== undefined) {
            step.title = this.injectVariables(
              step.when.title[this.variables[step.when.variable]]
            );
          }
          // Caption
          if (step.when.caption !== undefined) {
            step.caption = this.injectVariables(
              step.when.caption[this.variables[step.when.variable]]
            );
          }
          // Placeholder
          if (step.when.placeholder !== undefined) {
            step.placeholder = this.injectVariables(
              step.when.placeholder[this.variables[step.when.variable]]
            );
          }
          // Image
          if (step.when.image !== undefined) {
            step.image = step.when.image[this.variables[step.when.variable]];
          }
        } else if (step.title !== undefined) {
          step.title = this.injectVariables(step.title);
        }
      },
      day: function () {
        this.setVariableFromDate();
      },
      month: function () {
        this.setVariableFromDate();
      },
      year: function () {
        this.setVariableFromDate();
      },
    },
    mounted() {
      // if clear=1 in url then don't load data
      if (window.location.search.indexOf("clear=1") !== -1) {
        this.currentStepIndex = 0;

        return;
      }

      PERSIST_FIELDS.forEach((key) => {
        if (localStorage[key]) {
          try {
            const stored = JSON.parse(localStorage[key]);

            if (stored) {
              if (key === "currentStepIndex") {
                // start the quiz
                window.scrollTo(0, 0);
                sections.item(0).style.display = "none";
                sections.item(1).style.display = "block";

                document.body.classList.add("quiz-started");

                var searchParams = new URLSearchParams(window.location.search);

                if (searchParams.has("quizStep")) {
                  this[key] = 7;
                } else {
                  this[key] = stored;
                }
              } else {
                this[key] = stored;
              }
            }
          } catch (e) {
            //
          }
        }
      });
    },
    data() {
      var days = [];
      for (var day = 1; day <= 31; day++) {
        days.push(day);
      }

      var months = Array.from({ length: 12 }, (e, i) => {
        return new Date(null, i + 1, null).toLocaleDateString("en", {
          month: "short",
        });
      });

      var years = [];
      var currentYear = new Date().getFullYear();
      for (var year = currentYear; year >= 1930; year--) {
        years.push(year);
      }

      return {
        asset_url: Shopify.asset_url,
        currentStepIndex: 0,
        error: null,
        totalSteps: Clinicians.QuizData.steps.length + 2,
        tags: [],
        goals: {},
        moving: false,
        day: "",
        month: "",
        year: "",
        variables: {},
        steps: Clinicians.QuizData.steps,
        days: days,
        months: months,
        years: years,
        emailAddress: "",
        firstName: "",
        lastName: "",
        emailOptIn: true,
        showingEmailModal: false,
        sendingEmail: false,
        sentEmail: false,
      };
    },
  });

  Clinicians.startQuiz = function () {
    window.scrollTo(0, 0);
    sections.item(0).style.display = "none";
    sections.item(1).style.display = "block";

    document.body.classList.add("quiz-started");

    // update the url
    if ("URLSearchParams" in window) {
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.set("quizStep", 1);
      searchParams.delete("clear");

      var newRelativePathQuery =
        window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }

    if (typeof window.dataLayer !== "undefined") {
      window.dataLayer.push({
        event: "quizStarted",
      });
    }
  };

  if (startButton) {
    startButton.addEventListener("click", function (e) {
      e.preventDefault();
      Clinicians.startQuiz();
    });
  }

  Clinicians.qs = new URLSearchParams(window.location.search);

  if (Clinicians.qs.has("start")) {
    Clinicians.startQuiz();
  }
});
